import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import ReactTooltip from "react-tooltip";
import { withTranslation } from "react-i18next";

class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rowKeyIdx: null,
      selectedRow: null,
      selectedRowsIdentifierArray: [],
      expandRows: {},
      data: [],
    };

    this.rowClassNameFormat = this.rowClassNameFormat.bind(this);
    this.rowKeyDown = this.rowKeyDown.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onSingleSelect = this.onSingleSelect.bind(this);
    this.onSelectAll = this.onSelectAll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.onExpand = this.onExpand.bind(this);
    this.expandFormatter = this.expandFormatter.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (
      props.selectedRows.length !== state.selectedRowsIdentifierArray.length
    ) {
      state.selectedRowsIdentifierArray = props.selectedRows.map(
        (x) => x[props.keyField]
      );
    }

    return state;
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    // KeyNav
    if (this.props.keyNav) {
      ReactDOM.findDOMNode(this.refs.table).addEventListener(
        "keydown",
        this.rowKeyDown,
        true
      );
    }

    if (this.props.expandable) {
      //Modal içlerinde expandable olan tabloların verileri gelmemesinden dolayı pre-render yapıp componentDidUpdate tetiklenmesi için eklendi.
      this.setState({ expandRows: {} });
    }
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    const { data } = this.props;

    return data.length > 0;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // Tooltip Rebuild
    ReactTooltip.rebuild();

    // Table tr focus tabindex attr
    let rows = ReactDOM.findDOMNode(this.refs.table).querySelectorAll(
      "tbody tr"
    );
    for (const key in rows) {
      let i = parseInt(key) + 2;
      if (rows.hasOwnProperty(key)) {
        let elm = rows[key];
        elm.setAttribute("tabindex", i);
      }
    }

    // Selected Rows
    if (
      snapshot &&
      this.props.expandable !== undefined &&
      this.state.data.length === 0
    ) {
      const { keyField, expandItem } = this.props;

      if (this.props.expandable) {
        let data = [];
        let expandRows = {};
        for (const row of this.props.data) {
          const checkExpandable = row[expandItem].length > 0;

          data.push(row);

          if (checkExpandable) {
            let expandRow = {
              ...row,
              ...{
                id: "expand_" + row[keyField],
                parentId: row[keyField],
                expand: true,
              },
            };
            data.push(expandRow);
            expandRows[row[keyField]] = expandRow;
          }
        }

        this.setState({
          data,
          expandRows,
        });
      }

      if (this.props.data !== []) {
        this.handleResize();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    ReactDOM.findDOMNode(this.refs.table).removeEventListener(
      "keydown",
      this.rowKeyDown,
      true
    );
  }

  handleResize() {
    let tableContainer = ReactDOM.findDOMNode(this.refs.table);
    let table = tableContainer.firstChild;
    table.style.tableLayout = "fixed";
    if (tableContainer.clientWidth < table.clientWidth) {
      // tablo kaydırılabilir
      !tableContainer.classList.contains("scrollable") &&
        tableContainer.classList.add("scrollable");
    } else {
      tableContainer.classList.contains("scrollable") &&
        tableContainer.classList.remove("scrollable");
    }
  }

  rowClassNameFormat(row, rowIdx) {
    let result = "row-" + row[this.props.keyField];

    if (this.props.rowClassFormat) {
      result = result + " " + this.props.rowClassFormat(row, rowIdx);
    }

    if (row.recordStatus === 0 || row.recordStatus === 2)
      result = result + " row-account";

    // KeyNav
    if (this.props.keyNav && rowIdx === this.state.rowKeyIdx)
      result = result + " default-focus-row";

    if (row.expand) {
      result = "expand-row expand-row-" + row.parentId;

      if (!row.showExpand) result = result + " hide";
    }

    return result;
  }

  renderShowsTotal(start, to, total, tempT) {
    let tempArray= [];
    if (tempT("table.kayitaraligi").includes("Records")) {
      tempT("table.kayitaraligi").split("-").forEach((e,i) => {
        tempArray.push(e);
        if (i === 1) {
          tempArray.push(start);
          tempArray.push("-");
          tempArray.push(to);
        }
        if (i === 2){
          tempArray.push(total);
        }
      });
    }else{
      tempT("table.kayitaraligi").split("-").forEach((e,i) => {
        if (i === 0) {
          tempArray.unshift(total);
          tempArray.push(e);
          tempArray.push(start);
          tempArray.push("-");
          tempArray.push(to);
        }
        if (i === 1){
          tempArray.push(e);
        }
        if (i === 2){
          tempArray.push(e);
        }
      });
    }
    tempArray = tempArray.toString().replaceAll(",", " ");
    
    return (
      <span className="ml-2 text-primary">
        {tempArray}
      </span>
    );
  }

  rowKeyDown(e) {
    const rows = document.querySelectorAll(
      ".react-bootstrap-table > .table > tbody > tr"
    );
    const size = this.props.expandable ? 2 : 1;
    const totalSize = rows.length - size;
    let idx = this.state.rowKeyIdx;

    if (e.code == "KeyC" && (e.ctrlKey || e.metaKey)) {
      document.execCommand("copy");
    }

    if (e.code == "ArrowDown") {
      if (idx < totalSize) {
        idx = idx + size;
      } else idx = 0;
    }

    if (e.code == "ArrowUp") {
      if (idx > 0) {
        idx = idx - size;
      } else idx = totalSize;
    }

    if (e.code == "Space") e.target.click();
    if (e.code == "Enter") this.actionRef.onActionClick(this.props.data[idx]);

    if (e.code == "ArrowDown" || "ArrowUp" || "Space" || "Enter") {
      e.preventDefault();
      this.setState({ rowKeyIdx: idx });
      rows[idx]?.focus();
    }
  }

  onTableChange(type, { page, sizePerPage }) {
    this.props.onPageChange(page, sizePerPage);
  }

  onSelect(row, isSelect, rowIndex) {
    const { onSelect } = this.props;

    this.setState({
      rowKeyIdx: rowIndex,
    });

    // Fn Select Run
    if (onSelect) {
      onSelect(row, isSelect);
    }

    return true;
  }

  onSingleSelect(row, isSelect, rowIndex) {
    const { onSingleSelect } = this.props;

    this.setState(
      {
        selectedRowsIdentifierArray: [],
      },
      function () {
        this.setState({
          rowKeyIdx: rowIndex,
        });
      }
    );
    if (onSingleSelect) {
      onSingleSelect(row, isSelect);
    }

    return true;
  }

  onSelectAll(isSelect, rows) {
    const { onSelectAll } = this.props;

    // Fn SelectAll Run
    if (onSelectAll) {
      onSelectAll(rows, isSelect);
    }

    return true;
  }

  onExpand(e, row, rowIndex) {
    /*
     * Expand Hack
     * Row'a tıklayınca tabloya yeni DOM elementi ekliyor.
     */
    if (e.target.nodeName == "TD" || e.target.nodeName == "BDO") {
      const { keyField } = this.props;
      this.setState({ selectedRow: row });
      const expandRow = this.state.expandRows[row[keyField]];
      const expandRowEl = document.querySelector(
        `.expand-row-${row[keyField]}`
      );

      if (expandRow && expandRow.showExpand) {
        expandRow.showExpand = false;
      } else if (expandRow && expandRow.expandComponent) {
        expandRow.showExpand = true;
      }

      const resolve = (res) => {
        expandRow.expandComponent = res;
        expandRow.showExpand = true;
        this.setState({ expandRows: this.state.expandRows });

        if (expandRowEl) {
          const columnsSize = !this.props.hideSelection
            ? this.props.columns.length + 2
            : this.props.columns.length + 1;
          expandRowEl
            .querySelector(`.expand-row-${row[keyField]} td.expand-cell`)
            .setAttribute("colspan", columnsSize);
        }
      };

      if (expandRow && !expandRow.expandComponent) {
        this.props.expandComponent(row, resolve);
      }
    }
  }

  expandFormatter(cell, row, rowIndex, formatExtraData) {
    const { expandItem } = this.props;
    // const checkExpandable = row[expandItem].length > 0;

    return (
      <React.Fragment>
        {!row.expand && (
          <bdo style={{ padding: "6px", display: "block" }}>
            {" "}
            {formatExtraData[cell]}{" "}
          </bdo>
        )}
        {row.expand && <div className="row-expand">{row.expandComponent}</div>}
      </React.Fragment>
    );
  }
  

  render() {
    const { t } = this.props;                    /* added line */
    const {
      data,
      expandable,
      keyField,
      pagination,
      page,
      totalSize,
      selectable,
      isMultiSelect,
      hideSelection,
      sizePerPage
    } = this.props;
    let columns = this.props.columns;

    if (expandable) {
      columns = this.props.columns.slice();
      columns.unshift({
        text: "",
        dataField: "expanded",
        formatter: this.expandFormatter,
        formatExtraData: { undefined: "..." },
        style: { textAlign: "center", cursor: "pointer", padding: 0 },
        classes: "expand-cell",
        headerStyle: { width: "45px" },
      });
    }

    const paginationOpt = {
      page,
      hideSizePerPage: true,
      sizePerPage,
      totalSize: totalSize,
      showTotal: true,
      paginationTotalRenderer:(start, to, total) => this.renderShowsTotal(start, to, total, t),
    };

    let selectRowOpt = null;
    if (!hideSelection) {
      selectRowOpt = {
        mode: isMultiSelect ? "checkbox" : "radio",
        selectionHeaderRenderer: ({ mode, checked, indeterminate }) =>
          mode === "checkbox" && (
            <input
              type={mode}
              checked={checked}
              onChange={() => {}}
              ref={(input) => {
                if (input) {
                  input.indeterminate = indeterminate;
                }
              }}
            />
          ),
        selected: this.state.selectedRowsIdentifierArray,
        classes: "selected",
        clickToSelect: true,
        onSelect: isMultiSelect ? this.onSelect : this.onSingleSelect,
        onSelectAll: isMultiSelect ? this.onSelectAll : null,
      };
    }

    const selectRowProp = !hideSelection ? { selectRow: selectRowOpt } : {};

    const rowEvents = expandable ? { onClick: this.onExpand } : {};

    return (
      <React.Fragment>
        <BootstrapTable
          ref="table"
          keyField={keyField}
          hover
          data={expandable ? this.state.data : data}
          columns={columns}
          remote={{ pagination }}
          bordered={false}
          onTableChange={this.onTableChange}
          headerWrapperClasses="thead-primary"
          classes="table table-bordered"
          headerClasses="tableHeader"
          wrapperClasses="table-responsive overflow-hidden"
          noDataIndication={t("table.veriYok")}                                       /* updated line */
          rowClasses={this.rowClassNameFormat}
          pagination={pagination ? paginationFactory(paginationOpt) : null}
          rowEvents={rowEvents}
          bootstrap4
          {...selectRowProp}
        />
      </React.Fragment>
    );
  }
}
Table.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  keyField: PropTypes.string,
  pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  page: PropTypes.number,
  sizePerPage: PropTypes.number,
  totalSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onSelect: PropTypes.func,
  onSingleSelect: PropTypes.func,
  onSelectAll: PropTypes.func,
  selectable: PropTypes.bool,
  actionButtonsRef: PropTypes.object,
  keyNav: PropTypes.bool,
  expandable: PropTypes.bool,
  expandComponent: PropTypes.func,
  expandItem: PropTypes.string,
  rowClassFormat: PropTypes.func,
  selectedRows: PropTypes.arrayOf(PropTypes.object),
  hideSelection: PropTypes.bool,
};
Table.defaultProps = {
  data: [],
  columns: [],
  pagination: true,
  page: 1,
  sizePerPage: 50,
  selectable: true,
  keyNav: true,
  selectedRows: [],
};
export default withTranslation()(Table);
